import { useState } from "react";
import { Message, User } from "../types";
import { uploadFile } from "../axios/uploadFiles";
import useAppStore from "../stores/appStore";

type SendMessage = React.Dispatch<React.SetStateAction<Message[]>>;

export const usePhotoUploader = (
  sendMessage: SendMessage,
  currentUser: User,
) => {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const { focus, domain } = useAppStore();

  const handlePhotoUpload = async (file: File) => {
    if (!file) return;

    setIsUploading(true);
    try {
      const photoResponse = await uploadFile(file, "image");
      const finalURL = photoResponse.file_url;

      const photoMessage: Message = {
        message_id: String(Date.now() + Math.random()),
        from_user: currentUser,
        text: file.name,
        file_url: finalURL,
        type: "image",
        is_bot: false,
        date: new Date().toISOString(),
        chat: {
          id: currentUser.id,
          type: "private",
        },
        user_id: currentUser.id,
        message_type: "default",
        focus,
        domain,
      };

      sendMessage((prev) => [...prev, photoMessage]);
    } catch (error) {
      console.error("Failed to upload photo:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return { isUploading, handlePhotoUpload };
};
